/**
 * id {number, string} Column unique identificator
 * label {string} Column title
 * field_name {string} Column string identificator, used for slot reference
 * source_field {string}  Field name in the source data
 * showColumn {boolean} Enable the columns by default
 * alwaysVisible {boolean} Block making column visible / hidden
 * pinned {boolean} Pin the column
 * suppressSorting {boolead} Disable sorting
 * align {string} column alignment left/center/right
 */

export default [
  {
    id: 1,
    label: '',
    field_name: 'join',
    source_field: 'streaming_host_url',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
    suppressSorting: true,
  },
  {
    id: 2,
    label: '',
    field_name: 'details',
    source_field: 'webackend_id',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
    suppressSorting: true,
  },
  {
    id: 3,
    label: 'Date',
    field_name: 'scheduled_at',
    source_field: 'date',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
  },
  {
    id: 4,
    label: 'Time',
    field_name: 'time',
    source_field: 'descriptive_time',
    showColumn: true,
    alwaysVisible: true,
    pinned: true,
    suppressSorting: true,
  },
  {
    id: 5,
    label: 'Length',
    field_name: 'duration_minutes',
    source_field: 'duration_minutes',
    showColumn: true,
    pinned: false,
  },
  {
    id: 6,
    label: 'Day',
    field_name: 'day',
    source_field: 'day',
    showColumn: false,
    pinned: false,
  },
  {
    id: 7,
    label: 'Class Type',
    field_name: 'class_type',
    source_field: 'class_type_label',
    showColumn: true,
    alwaysVisible: true,
    pinned: false,
  },
  {
    id: 8,
    label: 'First Name',
    field_name: 'learner_first_name',
    source_field: 'learner_first_name',
    showColumn: false,
    pinned: false,
  },
  {
    id: 9,
    label: 'Last Name',
    field_name: 'learner_last_name',
    source_field: 'learner_last_name',
    showColumn: false,
    pinned: false,
  },
  {
    id: 10,
    label: 'Learner Email',
    field_name: 'email',
    source_field: 'learner_email',
    showColumn: true,
    pinned: false,
    suppressSorting: true,
  },
  {
    id: 11,
    label: 'Organization',
    field_name: 'organization_id',
    source_field: 'organization',
    showColumn: false,
    pinned: false,
  },
  {
    id: 12,
    label: 'Level',
    field_name: 'level',
    source_field: 'level',
    showColumn: true,
    pinned: false,
  },
  {
    id: 13,
    label: 'Topic',
    field_name: 'topic',
    source_field: 'topic',
    showColumn: true,
    pinned: false,
  },
  {
    id: 14,
    label: 'Lesson',
    field_name: 'lesson_title',
    source_field: 'lesson_title',
    showColumn: true,
    pinned: false,
  },
  {
    id: 15,
    label: 'Feedback Status',
    field_name: 'feedback_submitted',
    source_field: 'feedback_submitted',
    showColumn: true,
    pinned: false,
  },
  {
    id: 16,
    label: 'Class Rating',
    field_name: 'learner_found_class_helpful',
    source_field: 'learner_found_class_helpful',
    showColumn: false,
    pinned: false,
  },
  {
    id: 17,
    label: '# of Reservations',
    field_name: 'number_of_participants',
    source_field: 'number_of_participants',
    showColumn: true,
    pinned: false,
  },
  {
    id: 18,
    label: 'Student Cancel Time',
    field_name: 'canceled_at',
    source_field: 'canceled_at',
    showColumn: false,
    pinned: false,
  },
  {
    id: 19,
    label: 'Class ID',
    field_name: 'webackend_id',
    source_field: 'webackend_id',
    showColumn: false,
    pinned: false,
  },
  {
    id: 20,
    label: 'Training Plan',
    field_name: 'training_plan_slug',
    source_field: 'training_plan',
    showColumn: false,
    pinned: false,
  },
];
